import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastComponent } from '../toast/toast.component';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'shared-core-toast-container',
  imports: [CommonModule, ToastComponent],
  templateUrl: './toast-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  private readonly toastService = inject(ToastService);

  readonly toasts = computed(() => this.toastService.toasts);

  readonly isLoading = computed(() => this.toastService.hasObservableToasts());

  removeToast(toastId: string) {
    this.toastService.startToastRemovalTimer(toastId, 0);
  }
}
